import React from "react";
import { COMPANY } from "../data/site";

export const WhatsAppButton = () => {
  const message = encodeURIComponent(
    "Hi IDEAL ENTERPRISES, I'd like to discuss a project requirement."
  );
  return (
    <a
      data-testid="floating-whatsapp"
      href={`https://wa.me/${COMPANY.whatsapp}?text=${message}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 right-6 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-emerald-500/40 animate-ping" />
      <span className="relative w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-600 grid place-items-center shadow-lg shadow-emerald-500/30 btn-lift">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="w-7 h-7 fill-white"
          aria-hidden="true"
        >
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.65 3.41 4.554 4.34.616.302 2.69 1.196 3.36 1.196.74 0 2.194-.43 2.5-1.218.158-.402.158-.762.115-.86-.085-.4-.93-.5-1.36-.5z"/>
          <path d="M16.002 0C7.165 0 .003 7.16.003 16c0 2.81.74 5.45 2.025 7.74L0 32l8.46-2.225A15.92 15.92 0 0 0 16 32c8.84 0 16-7.16 16-16 0-8.84-7.16-16-15.998-16zM26.3 22.852c-.4 1.13-2.318 2.16-3.244 2.246-.92.083-1.84.13-3.07-.21a14.34 14.34 0 0 1-3.69-1.52 14.5 14.5 0 0 1-3.61-2.93 14.7 14.7 0 0 1-2.97-3.63 14.55 14.55 0 0 1-1.55-3.7c-.42-1.27-.36-2.18-.27-3.12.1-.95 1.13-2.86 2.26-3.27.51-.18 1.06-.18 1.43.1.4.3 1.84 4.31 1.87 4.43.07.23-.06.43-.18.55-.4.4-1.05.97-1.05 1.39 0 .2.07.42.16.6.5 1.03 1.4 2.18 2.32 3.06.93.89 2.04 1.76 3.09 2.27.21.1.4.13.6.13.36 0 .79-.6 1.18-.93.32-.27.66-.27.92-.16.4.16 2.7 1.27 3.16 1.5.13.06.21.15.21.27.04.45-.04 1.03-.27 1.66z"/>
        </svg>
      </span>
    </a>
  );
};
